import React, { useEffect, useState, useCallback } from "react";
import Header from "./Comman/Header";
import axios from "axios";
import Pagination from "./Comman/Pagination";

export default function HeritageIncome() {

  const [data, setdata] = useState([]);
  const [settings, setsettings] = useState([]);
  const username = localStorage.getItem("username");
  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [merged, setMerged] = useState([]);
  const [correctRank, setCorrectRank] = useState(null);

  const [pages, setPages] = useState(1);


  const getPrime = useCallback(async () => {
    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "prime",
        submethod: "getlist",
        key: process.env.REACT_APP_KEY,
      });

      if (!res.data.error) {
        setsettings(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching prime rewards:", error);
    }
  }, []);


  const getData = useCallback(async () => {
    if (!username) {
      return;
    }
    setisLoading(true);

    await axios
      .post(process.env.REACT_APP_BACKEND_LINK, {
        method: "prime",
        submethod: "getbyid",
        username: username,
        key: process.env.REACT_APP_KEY,
        page: currentPage,
        pageSize: pageSize,
      })
      .then((res) => {
        setisLoading(false);

        if (res.data.error) {
          return "";
        }

        setdata(res.data.data);
        setCorrectRank(res.data.correctRank?.data || null);
        setPages(Math.ceil(res.data.dataLength / pageSize));
      });
  }, [username, currentPage, pageSize]);

  useEffect(() => {
    if (!settings || !correctRank) return;

    const list = settings.map(item => {
      const userStatus = data.find(u => u.rankid === item.rankid);

      // Find the allow status for the rank
      const statusForRank = correctRank.find(r => r.rankid === item.rankid);

      return {
        ...item,
        status: userStatus ? userStatus.status : "",
        timelineAchieved: statusForRank ? statusForRank.allow : false
      };
    });

    setMerged(list);
  }, [settings, data, correctRank]);

  useEffect(() => {
    getData();
    getPrime()
  }, [getData, getPrime]);


  return (
    <>
      <div className="body-bg">
        <Header />
        <section className="nftmax-adashboard nftmax-show mt-4 setting-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12">

                {/* Card Container */}
                <div className="db-profile-card mb-5">

                  {/* Card Header */}
                  <div className="db-sec-hdr">
                    <div className="db-sec-dot"></div>
                    <div className="db-sec-title">Prime Reward</div>
                  </div>

                  <div className="card-body p-0 mt-3">
                    <div className="table-responsive">
                      <table className="table table-dashboard-premium align-middle mb-0" style={{ minWidth: '900px' }}>
                        <thead className="text-uppercase small">
                          <tr>
                            <th scope="col" className="ps-4 py-3">Sr.</th>
                            <th scope="col" className="py-3">Rank Name</th>
                            <th scope="col" className="py-3">Reward</th>
                            <th scope="col" className="py-3">LegA</th>
                            <th scope="col" className="py-3">LegB</th>
                            <th scope="col" className="py-3">OtherLeg</th>
                            <th scope="col" className="pe-4 py-3 text-end">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading && !merged.length ? (
                            <tr>
                              <td colSpan="7" className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                              </td>
                            </tr>
                          ) : !merged.length ? (
                            <tr>
                              <td colSpan="7" className="text-center py-5 text-slate-400">
                                <p className="mb-0">No data found</p>
                              </td>
                            </tr>
                          ) : (
                            merged.map((ele, i) => {
                              const index = currentPage * pageSize - pageSize + (i + 1);
                              return (
                                <tr key={i} className="table-tr-premium">
                                  <td className="ps-4">
                                    <span className="text-slate-400 small">{index}</span>
                                  </td>

                                  <td>
                                    <span className="fw-semibold text-white-custom">{ele.rank}</span>
                                  </td>

                                  <td>
                                    <span className="fw-bold text-success">${ele.reward}</span>
                                  </td>

                                  <td>
                                    <span className="text-slate-400 small">${ele.legA}</span>
                                  </td>

                                  <td>
                                    <span className="text-slate-400 small">${ele.legB}</span>
                                  </td>

                                  <td>
                                    <span className="text-slate-400 small">${ele.otherLeg}</span>
                                  </td>

                                  <td className="pe-4 text-end">
                                    {ele.timelineAchieved === true && ele.status === false ? (
                                      <span className="badge bg-soft-warning">
                                        <i className="fa fa-clock me-1"></i> Achieved
                                      </span>
                                    ) : ele.status === true ? (
                                      <span className="badge bg-soft-success">
                                        <i className="fa fa-check-circle me-1"></i> Approved
                                      </span>
                                    ) : ele.timelineAchieved === false && ele.status === false ? (
                                      <span className="badge bg-soft-danger" title="Timeline over">
                                        <i className="fa fa-check-circle me-1"></i> Achieved
                                      </span>
                                    ) : (
                                      <span className="badge bg-soft-danger">
                                        <i className="fa fa-times-circle me-1"></i> Not Achieved
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Card Footer for Pagination */}
                  <div className="card-footer bg-transparent border-top border-secondary border-opacity-10 p-4">
                    <Pagination
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      pages={pages}
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
